import React from "react";
import { Helmet } from "react-helmet-async";
import Posters from "../components/x-mas-2024-poster"; // Adjust import path as needed
import "./events.css";

const Events = () => {
  return (
    <>
      <Helmet>
        <title>All Festivals & Bazaars | BizBaz Events Nairobi</title>
        <meta
          name="description"
          content="Discover Nairobi's premier open-air cultural festivals and bazaars. Browse upcoming dates, location info, tickets, and vendor details."
        />
        <meta property="og:title" content="All Festivals & Bazaars | BizBaz Events" />
        <meta
          property="og:description"
          content="Where cultures connect in Nairobi. 200+ artisan vendors, food court, live music, and family experiences."
        />
        <link rel="canonical" href="https://bizbazevents.com/events" />
      </Helmet>

      <div className="events-page">
        {/* Header Section */}
        <header className="events-header">
          <span className="events-eyebrow">CURATED EXPERIENCES</span>
          <h1 className="events-heading">WHERE CULTURES CONNECT</h1>
          <p className="events-subheading">
            Nairobi's favourite open-air festival — 200+ artisan vendors, gourmet food court, live music &amp; family moments.
          </p>
        </header>

        {/* Events Directory List */}
        <div className="events-list">
          <Posters
            index={0}
            imagepath="/images/posters/2024/Christmas-Edition-Dec-2026.png"
            headertext="Bizarre Bazaar Christmas Edition Festival 2026"
            venue="KSTVET, Off UN Avenue, Gigiri, Nairobi"
            date="Fri 11th, Sat 12th & Sun 13th December 2026"
            vendors="Vendor Applications — Open"
            button="/events/christmas"
          />

          <Posters
            index={1}
            imagepath="/images/posters/2024/Global_village_edition_2026.png"
            headertext="Bizarre Bazaar Global Village Edition Festival 2026"
            venue="KSTVET, Off UN Avenue, Gigiri, Nairobi"
            date="Sat 26th & Sun 27th September 2026"
            vendors="Vendor Applications — Closed"
            button="/events/global-village"
          />

          <Posters
            index={2}
            imagepath="/images/easter-2026-poster.jpg"
            headertext="Bizarre Bazaar Easter Festival 2026"
            venue="KSTVET, Off UN Avenue, Gigiri, Nairobi"
            date="Sat 28th & Sun 29th March 2026"
            vendors="Vendor Applications — Closed"
            button="/events/easter"
          />
        </div>
      </div>
    </>
  );
};

export default Events;